export const dataLibTime = [{
  word: 'mennwit',
  partOfSpeech: 'N',
  definition: ['00:00', 'midnight'],
  egSentenceKw: 'Yo kay wivé bò mennwit.',
  egSentenceEn: 'They will arrive near midnight.',
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. minuit]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'yonnè',
  partOfSpeech: 'N',
  definition: ['01:00', 'one o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. une heure]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dézè',
  partOfSpeech: 'N',
  definition: ['02:00', 'two o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. deux heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'twazè',
  partOfSpeech: 'N',
  definition: ['03:00', 'three o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. trois heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'katwè',
  partOfSpeech: 'N',
  definition: ['04:00', 'four o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. quatre heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'senkè',
  partOfSpeech: 'N',
  definition: ['05:00', 'five o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. cinq heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sizè',
  partOfSpeech: 'N',
  definition: ['06:00', 'six o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. six heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'sétè',
  partOfSpeech: 'N',
  definition: ['07:00', 'seven o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. sept heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'ywitè',
  partOfSpeech: 'N',
  definition: ['08:00', 'eight o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. huit heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'névè',
  partOfSpeech: 'N',
  definition: ['09:00', 'nine o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. huit heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'dizè',
  partOfSpeech: 'N',
  definition: ['10:00', 'ten o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. dix heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'wonzè',
  partOfSpeech: 'N',
  definition: ['11:00', 'eleven o\'clock'],
  egSentenceKw: null,
  egSentenceEn: null,
  synonym: [null],
  antonym: [null],
  etymology: '[< Fr. onze heures]',
  dialect: '🇱🇨',
  variant: [null],
}, {
  word: 'midi',
  partOfSpeech: 'N',
  definition: ['12:00', 'noon', 'midday'],
  egSentenceKw: 'Lè i té midi, nonm-lan vini.',
  egSentenceEn: 'When it was noon, the man came.',
  synonym: ['gwan jou', 'gwan lajouné'],
  antonym: ['gwo lannwit'],
  etymology: '[< Fr. midi]',
  dialect: '🇱🇨',
  variant: [null],
},
];
